/**
 * Auth API Service — Login & Forgot Password
 */

import {
  CHANGE_PASSWORD_API_URL,
  FORGOT_PASSWORD_API_URL,
  GET_SECURITY_QUESTION_API_BASE_URL,
  LOGIN_API_URL,
  SECURITY_QUESTIONS_API_URL,
  API_BASE_URL
} from "../config/constants";
import { apiFetch } from "../utils/apiClient";




/**
 * Resets a user's password by calling the backend API.
 */
const extractErrorMessage = async (res) => {
  try {
    const data = (await res.json()) ;
    if (data?.message) {
      return data.message;
    }
  } catch {
    // ignore parse errors and fallback to default text
  }
  return "Request failed. Please try again.";
};

/**
 * Authenticates a user against the backend API.
 */
export async function loginUser(payload) {
  const response = await apiFetch(LOGIN_API_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  }, "Login failed", { passthrough: [401] });

  const contentType = response.headers.get("content-type");
  if (!contentType || !contentType.includes("application/json")) {
    const textResponse = await response.text();
    throw new Error(textResponse || "Login failed");
  }

  const data = (await response.json());

  if (!response.ok || data.status !== "SUCCESS" || !data.token) {
    throw new Error(data.message || "Login failed");
  }

  return data;
}

export async function getSecurityQuestionByUserId(
  userId,
) {
  const res = await apiFetch(
    `${GET_SECURITY_QUESTION_API_BASE_URL}/${encodeURIComponent(userId)}`,
    {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    },
    "Request failed. Please try again.",
    { passthrough: [401] },
  );

  if (!res.ok) {
    throw new Error(await extractErrorMessage(res));
  }

  return (await res.json());
}

export async function getAllSecurityQuestions() {
  const res = await apiFetch(SECURITY_QUESTIONS_API_URL, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  }, "Request failed. Please try again.", { passthrough: [401] });

  if (!res.ok) {
    throw new Error(await extractErrorMessage(res));
  }

  return (await res.json());
}

export async function resetPassword(payload) {
  const res = await apiFetch(FORGOT_PASSWORD_API_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  }, "Request failed. Please try again.", { passthrough: [401] });

  if (!res.ok) {
    throw new Error(await extractErrorMessage(res));
  }
}

export async function changePassword(payload) {
  const token =
    sessionStorage.getItem("token") ||
    sessionStorage.getItem("authToken") ||
    sessionStorage.getItem("accessToken");
  const tokenType = sessionStorage.getItem("tokenType") || "Bearer";

  const normalizedToken = token
    ? token
        .replace(/^"|"$/g, "")
        .replace(/^Bearer\s+/i, "")
        .trim()
    : "";

  const headers = {
    "Content-Type": "application/json",
  };

  if (normalizedToken) {
    headers.Authorization = `${tokenType} ${normalizedToken}`;
  }

  const res = await apiFetch(CHANGE_PASSWORD_API_URL, {
    method: "POST",
    headers,
    body: JSON.stringify(payload),
  }, "Request failed. Please try again.", { passthrough: [401] });

  if (!res.ok) {
    throw new Error(await extractErrorMessage(res));
  }
}
